export const mapResponse400 = () => false;
